import { createApiClient } from "./apiClient";
import { deviceSettings, notificationSessionEpoch, stopBrowserNotifications } from "./notificationSession";
const api = createApiClient();
let tone;
export function playNotificationSound() {
  if (!tone) tone = new Audio(`${process.env.PUBLIC_URL || ""}/sounds/notification.wav?v=soft-1`);
  tone.currentTime = 0;
  return Promise.resolve(tone.play()).then(() => true, () => false);
}
export const supportsAdminPush = () => window.isSecureContext && "Notification" in window && "serviceWorker" in navigator && "PushManager" in window;
const publicKeyBytes = (value) => Uint8Array.from(atob(value.replace(/-/g, "+").replace(/_/g, "/")), (char) => char.charCodeAt(0));

export async function activateAdminPush(userId, sound = true, requestPermission = true) {
  const epoch = notificationSessionEpoch();
  if (!supportsAdminPush()) throw new Error("Este navegador no permite avisos de escritorio. Usá Firefox o Edge con HTTPS (o localhost).");
  const permission = requestPermission ? await Notification.requestPermission() : Notification.permission;
  if (permission !== "granted") throw new Error("Los avisos están bloqueados. Permití las notificaciones de este sitio en la configuración del navegador.");
  const { data } = await api.get("/api/notificaciones-admin/config");
  const registration = await navigator.serviceWorker.register(`${process.env.PUBLIC_URL || ""}/admin-notifications-sw.js`, { scope: "/" });
  await navigator.serviceWorker.ready;
  let subscription = await registration.pushManager.getSubscription();
  if (subscription?.options?.applicationServerKey) {
    const current = new Uint8Array(subscription.options.applicationServerKey), expected = publicKeyBytes(data.publicKey);
    if (current.length !== expected.length || current.some((byte, index) => byte !== expected[index])) {
      await subscription.unsubscribe(); subscription = null;
    }
  }
  if (!subscription) subscription = await registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: publicKeyBytes(data.publicKey) });
  await api.post("/api/notificaciones-admin/suscripcion", { subscription: subscription.toJSON(), sound });
  if (epoch !== notificationSessionEpoch()) { await subscription.unsubscribe(); throw new Error("La sesión cambió. Volvé a activar los avisos."); }
  await deviceSettings({ enabled: true, userId: String(userId), sound });
  return subscription;
}
export async function updatePushSound(userId, sound) {
  const epoch = notificationSessionEpoch();
  const subscription = await navigator.serviceWorker?.getRegistration("/").then((registration) => registration?.pushManager.getSubscription());
  if (!subscription) throw new Error("Primero activá los avisos de escritorio.");
  await api.post("/api/notificaciones-admin/suscripcion", { subscription: subscription.toJSON(), sound });
  if (epoch !== notificationSessionEpoch()) return;
  await deviceSettings({ enabled: true, userId: String(userId), sound });
}
export async function showAdminDesktopNotification(item, userId, sound) {
  if (!supportsAdminPush() || Notification.permission !== "granted") return;
  const registration = await navigator.serviceWorker.getRegistration("/");
  if (!registration?.active) throw new Error("Volvé a activar los avisos de escritorio para recibir las ventanas emergentes.");
  return new Promise((resolve, reject) => {
    const channel = new MessageChannel();
    const timer = setTimeout(() => { channel.port1.close(); reject(new Error("No respondió el servicio de avisos de escritorio.")); }, 5000);
    channel.port1.onmessage = (event) => {
      clearTimeout(timer); channel.port1.close();
      if (event.data?.error) reject(new Error(event.data.error)); else resolve(event.data);
    };
    registration.active.postMessage({ type: "BINDER_DISPLAY_ADMIN_NOTIFICATION", payload: {
      ...item, userId: String(userId), sound,
    } }, [channel.port2]);
  });
}
export async function renewAdminPush(userId, sound) {
  const epoch = notificationSessionEpoch();
  if (!supportsAdminPush() || Notification.permission !== "granted") return;
  const registration = await navigator.serviceWorker.getRegistration("/");
  const subscription = await registration?.pushManager.getSubscription();
  if (subscription) {
    const { data } = await api.post("/api/notificaciones-admin/estado", { endpoint: subscription.endpoint });
    if (epoch !== notificationSessionEpoch()) return;
    if (data.registered) return;
    await subscription.unsubscribe();
  }
  if (epoch !== notificationSessionEpoch()) return;
  await activateAdminPush(userId, sound, false);
}
export { deviceSettings, stopBrowserNotifications };
